export const EDIT_CREDIT_CARD = 'PrimoProfile/EditCreditCard';
export const EDIT_BANK_ACCOUNT = 'PrimoProfile/EditBankAccount';
export const EDIT_BILLING_INFORMATION = 'PrimoProfile/EditBillingInformation';
export const EDIT_INVOICE_INFORMATION = 'PrimoProfile/EditInvoiceInformation';
export const EDIT_CUSTOMER_NOTES = 'PrimoProfile/EditCustomerNotes';
export const EDIT_BILLING_CONTACT = 'PrimoProfile/EditBillingContact';
export const EDIT_BILLING_ADDRESS = 'PrimoProfile/EditBillingAddress';
export const CANCEL_ACCOUNT = 'PrimoProfile/CancelAccount';
